export const apiKey = process.env.REACT_APP_MAP_API_KEY;

export const mapConfig = {
	zoom: 2,
	mapTypeControl: false,
	draggableCursor: 'default',
	streetViewControl: false,
	clickableIcons: false,
	centerPoint: {
		Lat: 35.87300409307751,
		Lon: -94.64392407969059,
	},
	zoomControlOptions: {
		style: '1',
		position: '9',
	},
	zoomControl: false,
	disableDefaultUI: true,
	mapStyles: [],
	fullscreenControl: false,
	fullscreenControlOptions: null,
	tilt: 0,
};

export const mapLayerMetaData = {
	type: 'geojson',
	data: {},
	layerConfig: {
		id: 'geojson',
		elevationScale: 1,
		borderColor: '#fff',
		lineJointRounded: false,
		lineMiterLimit: 4,
		material: true,
		pointRadiusMinPixels: 0,
		pointRadiusScale: 1,
		pointRadiusUnits: 'meters',
		coordinateOrigin: [0, 0, 0],
		modelMatrix: null,
		opacity: 0.5,
		visible: true,
		wrapLongitude: false,
		stroked: true,
		filled: true,
		extruded: false,
		lineWidthScale: 10,
		lineWidthMinPixels: 1,
		getRadius: 30,
		getLineWidth: 0.25,
		pickable: true,
		getLineColor: [255, 255, 255],
	},
};
